import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";
import {WatchService} from "../../services/watch.service";
import {Subject} from "rxjs/Subject";

@Component({
  selector: 'nv-ads-multipliers',
  templateUrl: './nv-ads-multipliers.component.html',
  styles: []
})
export class NvAdsMultipliersComponent implements OnInit, OnDestroy {
  
  VAL_TYPES = VALUE_TYPE;
  
  @Input() document:any;
  geoToAdd:string='ru';
  loadedGeosList:any[] = [
    {lang:"ru"},
    {lang:"en"}
  ]
  
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private watchService:WatchService,
              private collectionService:CollectionService) { }

  ngOnInit() {
    this.loadLocalesList();
  }
  
  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  
  loadLocalesList(){
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setSearchParams(paramsHelper.search()
        .addParam("_type", SEARCH_PROP_TYPES.STRING,
          DOCUMENT_TYPES.GEO).json
      )
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .takeUntil(this.unsubscribe)
      .subscribe(r => {
        this.loadedGeosList = r.documents;
        if (this.loadedGeosList.length > 0)
        {
          this.geoToAdd = this.loadedGeosList[0].lang;
        }
      });
  }
  
  onAddClick(){
    if (this.document.filter(geo => geo.lang == this.geoToAdd).length == 0)
    {
      this.document.push({lang:this.geoToAdd, multiplier:1.0});
      this.watchService.notify();
    }
  }
  
  onRemoved() {
    this.watchService.notify();
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-ads-multipliers/nv-ads-multipliers.component.ts